import React, { Component } from 'react';
import { Redirect, Route } from 'react-router';
import Index from '..';

export const isPatient = () => {
    var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
    if (user != null && user.type == "patient") {
        const token = localStorage.getItem("token");
        
        if (!token) {
            return false;
        } else {
            return true;
        }
    } else {
        return false;
    }
}

export const preCondition = (condition, WrappedComponent) => {
    return class extends Component {
        constructor() {
            super()
            this.state = {
                isAuth: ''
            }
        }
        componentWillMount = () => {
            this.setState({ isAuth: condition() })
        }

        render() {
            
            return (
                this.state.isAuth ?
                    <WrappedComponent {...this.props} /> : <Redirect to="/" />
            )
        }
    }
}

export const PatientPrivateRoute = ({ component: Component, ...rest }) => {
    var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
    let isPatientAuthorized = false
    if (user != null && user.type == "patient") {
        isPatientAuthorized = true
        // isPatientAuthorized(nextState, replace, callback);
        // toastr.error('Token either invalid or expired!')
        // replace('/')
    } else {
        isPatientAuthorized = false
    }

    return (
        <Route
            {...rest}
            render={(props) => isPatientAuthorized === true
                ? <Component {...props} />
                : <Redirect to={{ pathname: '/', state: { from: props.location } }} />}
        />
    )
}

export const SpecialistPrivateRoute = ({ component: Component, ...rest }) => {
    var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
    let isPatientAuthorized = false
    if (user != null && user.type == "specialist") {
        isPatientAuthorized = true
        // isPatientAuthorized(nextState, replace, callback);
        // toastr.error('Token either invalid or expired!')
        // replace('/')
    } else {
        isPatientAuthorized = false
    }

    return (
        <Route
            {...rest}
            render={(props) => isPatientAuthorized === true
                ? <Component {...props} />
                : <Redirect to={{ pathname: '/', state: { from: props.location } }} />}
        />
    )
}
export const AdminPrivateRoute = ({ component: Component, ...rest }) => {
    
    // var user = localStorage.getItem("roles") ? localStorage.getItem("roles").split(',') : [];
    let user = ['admin', 'finance']
    let isAdminAuthorized = false
    // 
    if (rest.location.pathname == '/user') {
        if (user.indexOf('admin') != -1) {
            isAdminAuthorized = true;
        } else {
            isAdminAuthorized = false;
        }
    }
    if (rest.location.pathname == '/user/disputes') {
        if (user.indexOf('admin') != -1) {
            isAdminAuthorized = true;
        } else {
            isAdminAuthorized = false;
        }
    }
    if (rest.location.pathname == '/user/superuser-dashboard') {
        if (user.indexOf('admin') != -1) {
            isAdminAuthorized = true;
        } else {
            isAdminAuthorized = false;
        }
    }

	if (rest.location.pathname == '/user/finance-dashboard') {
		if (user.indexOf('admin') != -1 || user.indexOf('finance') != -1) {
			isAdminAuthorized = true;
		} else {
            isAdminAuthorized = false;

		}
	}
	if (rest.location.pathname == '/user/feedbackuser') {
		if (user.indexOf('admin') != -1) {
			isAdminAuthorized = true;
		} else {
            isAdminAuthorized = false;

		}
	}
	if (rest.location.pathname == '/user/Images') {
		if (user.indexOf('admin') != -1 || user.indexOf('photouser') != -1) {
			isAdminAuthorized = true;
		} else {
            isAdminAuthorized = false;

		}
	}
	if (rest.location.pathname == '/user/currency-filter') {
		if (user.indexOf('admin') != -1 ) {
			isAdminAuthorized = true;
		} else {
            isAdminAuthorized = false;

		}
	}
	if (rest.location.pathname == '/user/userList') {
		if (user.indexOf('admin') != -1) {
			isAdminAuthorized = true;
		} else {
            isAdminAuthorized = false;

		}
	}
	if (rest.location.pathname == '/user/photouser') {
		if (user.indexOf('admin') != -1) {
			isAdminAuthorized = true;
		} else {
            isAdminAuthorized = false;
		}
	}
	if (rest.location.pathname == '/user/specialist-assisstant') {
		if (user.indexOf('admin') != -1) {
			isAdminAuthorized = true;
		} else {
            isAdminAuthorized = false;
		}
	}
	if (rest.location.pathname == '/user/vettinguser') {
		if (user.indexOf('admin') != -1) {
			isAdminAuthorized = true;
		} else {
            isAdminAuthorized = false;
		}
	}
	if (rest.location.pathname == '/user/add-blog') {
		if (user.indexOf('admin') != -1) {
			isAdminAuthorized = true;
		} else {
            isAdminAuthorized = false;
		}
	}
	if (rest.location.pathname == '/user/specialistuser') {
		if (user.indexOf('admin') != -1 || user.indexOf('vetting') != -1) {
			isAdminAuthorized = true;
		} else {
            isAdminAuthorized = false;
		}
	}
	if (rest.location.pathname == '/user/patients') {
		if (user.indexOf('admin') != -1 || user.indexOf('vetting') != -1) {
			isAdminAuthorized = true;
		} else {
            isAdminAuthorized = false;

		}
	}
	if (rest.location.pathname.match('user/verification')) {
		
		if (user.indexOf('admin') != -1 || user.indexOf('vetting') != -1) {
			isAdminAuthorized = true;
		} else {
            isAdminAuthorized = false;

		}
	}
	if (rest.location.pathname == '/user/financeuser') {
		if (user.indexOf('admin') != -1) {
			isAdminAuthorized = true;
		} else {
            isAdminAuthorized = false;

		}
	}
	if (rest.location.pathname == '/user/add-user') {
		if (user.indexOf('admin') != -1) {
			isAdminAuthorized = true;
		} else {
            isAdminAuthorized = false;

		}
	}
	
	// let userId = rest.params.id
	if (rest.location.pathname.includes('/user/edit-user/') ){
		if (user.indexOf('admin') != -1) {
			isAdminAuthorized = true;
		} else {
            isAdminAuthorized = false;

		}
	}
	if (rest.location.pathname.includes('/user/patient-appointments/')) {
		if (user.indexOf('admin') != -1) {
			isAdminAuthorized = true;
		} else {
            isAdminAuthorized = false;

		}
	}
	console.log("==>>", rest.location.pathname.includes('/user/language'))

	if (rest.location.pathname.includes('/user/disputes/')) {
		if (user.indexOf('admin') != -1) {
			isAdminAuthorized = true;
		} else {
			isAdminAuthorized = false;
			
		}
	}
	if (rest.location.pathname == '/user/language') {
		if (user.indexOf('admin') != -1) {
			isAdminAuthorized = true;
		} else {
			isAdminAuthorized = false;
			
		}
	}
	console.log("==>>isadminauthorized",user.indexOf('admin') != -1, isAdminAuthorized)
	if (rest.location.pathname == '/user/appointments') {
		if (user.indexOf('admin') != -1) {
			isAdminAuthorized = true;
		} else {
            isAdminAuthorized = false;

		}
	}
	if (rest.location.pathname.includes('/user/appointment-consultation/')){
		if (user.indexOf('admin') != -1) {
			isAdminAuthorized = true;
		} else {
            isAdminAuthorized = false;

		}
	}
	if (rest.location.pathname == '/user/add-email-template') {
		if (user.indexOf('admin') != -1) {
			isAdminAuthorized = true;
		} else {
            isAdminAuthorized = false;

		}
	}
	if (rest.location.pathname == '/user/email-templates') {
		if (user.indexOf('admin') != -1) {
			isAdminAuthorized = true;
		} else {
            isAdminAuthorized = false;

		}
	}
	if (rest.location.pathname.includes('/user/edit-email-template/')) {
		if (user.indexOf('admin') != -1) {
			isAdminAuthorized = true;
		} else {
            isAdminAuthorized = false;

		}
	}
	if (rest.location.pathname.includes('/user/emailTemplateView/')) {
		if (user.indexOf('admin') != -1) {
			isAdminAuthorized = true;
		} else {
            isAdminAuthorized = false;

		}
	}
	if (rest.location.pathname == '/user/pages') {
		if (user.indexOf('admin') != -1) {
			isAdminAuthorized = true;
		} else {
            isAdminAuthorized = false;

		}
	}
	if (rest.location.pathname.match('/user/edit-page/')) {
		if (user.indexOf('admin') != -1) {
			isAdminAuthorized = true;
		} else {
            isAdminAuthorized = false;

		}
	}
	if (rest.location.pathname == '/user/logs') {
		if (user.indexOf('admin') != -1) {
			isAdminAuthorized = true;
		} else {
            isAdminAuthorized = false;

		}
	}
	if (rest.location.pathname == '/user/Feedbacks') {
		if (user.indexOf('admin') != -1 || user.indexOf('feedback') != -1) {
			isAdminAuthorized = true;
		} else {
            isAdminAuthorized = false;
		}
	}
	if (rest.location.pathname == '/user/adminblogList') {
		if (user.indexOf('admin') != -1 ) {
			isAdminAuthorized = true;
		} else {
            isAdminAuthorized = false;
		}
	}
	if (rest.location.pathname == '/user/userSetting') {
		if (user.indexOf('admin') != -1 || user.indexOf('photouser') != -1 || user.indexOf('feedback') != -1 || user.indexOf('vetting') != -1  || user.indexOf('finance') != -1) {
			isAdminAuthorized = true;
		} else {
            isAdminAuthorized = false;
		}
	}
    return (	
        <Route
            {...rest}
            render={(props) => isAdminAuthorized == true
                ? <Component {...props} />
                : <Redirect to={{ pathname: '/', state: { from: props.location } }} />}
        />
    )
}

export const IsAuthorizedUrl = ({ component: Component, ...rest }) => {
    const appointmentId = localStorage.getItem("appointmentId");
    const availabilityId = localStorage.getItem("availabilityId");
    // 
    // if (!appointmentId) {
        // isPatientAuthorized = false;
    // }
    // isPatientAuthorized = true;
    let isUrlAuthorized = false
    if (!appointmentId) {
        isUrlAuthorized = false
        // isPatientAuthorized(nextState, replace, callback);
        // toastr.error('Token either invalid or expired!')
        // replace('/')
    } else {
        isUrlAuthorized = true
    }
    return (
        <Route
            {...rest}
            render={(props) => isUrlAuthorized === true
                ? <Component {...props} />
                : <Redirect to={{ pathname: '/dashboard/book-appointment', state: { from: props.location } }} />}
        />
    )
}